
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/posts/[slug]",
      function () {
        return require("private-next-pages/blog/posts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/posts/[slug]"])
      });
    }
  